import { useCallback, useMemo, useState } from 'react';
import { useGetDealerPartHistoryQuery } from '../../../api';

const pick = (obj, ...keys) => keys.reduce((a, k) => (obj?.[k] !== undefined ? ((a[k] = obj[k]), a) : a), {});

const normalizeContextFromRow = (row) => {
    const PartCode = row?.partCode ?? row?.PartCode ?? null;
    const PartDesc = row?.partDesc ?? row?.PartDesc ?? null;
    const DealerId = row?.dealerId ?? row?.DealerId ?? null;
    const DealerAddressId = row?.dealerAddressId ?? row?.DealerAddressId ?? row?.addrId ?? row?.AddrId ?? null;
    return { PartCode, PartDesc, DealerId, DealerAddressId };
};
const usePartHistoryData = () => {
    const [visible, setVisible] = useState(false);
    const [context, setContext] = useState(null);
    const [pagination, setPagination] = useState({ PageNumber: 1, PageSize: 10 });

    const openWithRow = useCallback((row) => {
        const ctx = normalizeContextFromRow(row);
        setContext(ctx);
        setPagination({ PageNumber: 1, PageSize: 10 });
        setVisible(true);
    }, []);

    const close = useCallback(() => setVisible(false), []);

    const shouldSkip = !visible || !context?.PartCode || !context?.DealerId || !context?.DealerAddressId;

    const { data, isLoading, isFetching, refetch } = useGetDealerPartHistoryQuery(
        {
            DealerId: context?.DealerId,
            DealerAddressId: context?.DealerAddressId,
            PartCode: context?.PartCode,
            PageNumber: pagination.PageNumber,
            PageSize: pagination.PageSize
        },
        { skip: shouldSkip }
    );

    const onPageChange = useCallback((event) => {
        const newPageNumber = Math.floor(event.first / event.rows) + 1;
        setPagination({ PageNumber: newPageNumber, PageSize: event.rows });
    }, []);

    const rows = useMemo(() => data?.rows ?? data?.Rows ?? [], [data]);
    const totalCount = useMemo(() => data?.totalCount ?? data?.TotalCount ?? 0, [data]);
    const loading = isLoading || isFetching;

    const headerInfo = useMemo(
        () => ({
            PartDesc: context?.PartDesc || ''
        }),
        [context]
    );

    return {
        visible,
        openWithRow,
        close,
        rows,
        totalCount,
        pagination,
        onPageChange,
        loading,
        headerInfo,
        refetch
    };
};

export default usePartHistoryData;
